import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function JoinFullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"join_full"}/>
}
